
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenApiKey } from './GenApiKey';
import { GenPointOfContact } from './GenPointOfContact';
import { GenRoleDefinition } from './GenRoleDefinition';
import moment from 'moment';

export class GenUser {

    id: number;
    accountEnabled: boolean;
    apiKey: string;
    apiKeys: GenApiKey[];
    approved: boolean;
    email: string;
    emailVerificationCode: string;
    emailVerified: boolean;
    enabled: boolean;
    expirationDate: moment.Moment;
    firstName: string;
    fullName: string;
    impersonating: boolean;
    joinDate: moment.Moment;
    lastLoginDate: moment.Moment;
    lastName: string;
    lastPasswordReset: moment.Moment;
    name: string;
    organization: string;
    originatingSystem: string;
    password: string;
    passwordResetCode: string;
    passwordResetTime: moment.Moment;
    phone: string;
    pointOfContact: GenPointOfContact;
    reason: string;
    requestReason: string;
    resettingPassword: boolean;
    roles: GenRoleDefinition[];
    username: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genUser: GenUser);
    constructor( id: number );

    constructor( input?: GenUser|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.accountEnabled = input.accountEnabled; // boolean [boolean]
            this.apiKey = input.apiKey; // string [string]
            if ( input.apiKeys && input.apiKeys.map ) { // list [GenApiKey]
                this.apiKeys = input.apiKeys.map( ( x: GenApiKey ) => {
                    return new GenApiKey( x );
                } );
            } else {
                this.apiKeys = input.apiKeys;
            }
            this.approved = input.approved; // boolean [boolean]
            this.email = input.email; // string [string]
            this.emailVerificationCode = input.emailVerificationCode; // string [string]
            this.emailVerified = input.emailVerified; // boolean [boolean]
            this.enabled = input.enabled; // boolean [boolean]
            if ( input.expirationDate && typeof input.expirationDate === 'string' ) {
                this.expirationDate = moment(input.expirationDate).utc();
            } else {
                this.expirationDate = input.expirationDate;
            }
            this.firstName = input.firstName; // string [string]
            this.fullName = input.fullName; // string [string]
            this.impersonating = input.impersonating; // boolean [boolean]
            if ( input.joinDate && typeof input.joinDate === 'string' ) {
                this.joinDate = moment(input.joinDate).utc();
            } else {
                this.joinDate = input.joinDate;
            }
            if ( input.lastLoginDate && typeof input.lastLoginDate === 'string' ) {
                this.lastLoginDate = moment(input.lastLoginDate).utc();
            } else {
                this.lastLoginDate = input.lastLoginDate;
            }
            this.lastName = input.lastName; // string [string]
            if ( input.lastPasswordReset && typeof input.lastPasswordReset === 'string' ) {
                this.lastPasswordReset = moment(input.lastPasswordReset).utc();
            } else {
                this.lastPasswordReset = input.lastPasswordReset;
            }
            this.name = input.name; // string [string]
            this.organization = input.organization; // string [string]
            this.originatingSystem = input.originatingSystem; // string [string]
            this.password = input.password; // string [string]
            this.passwordResetCode = input.passwordResetCode; // string [string]
            if ( input.passwordResetTime && typeof input.passwordResetTime === 'string' ) {
                this.passwordResetTime = moment(input.passwordResetTime).utc();
            } else {
                this.passwordResetTime = input.passwordResetTime;
            }
            this.phone = input.phone; // string [string]
            if( input.pointOfContact ) {
              this.pointOfContact = new GenPointOfContact( input.pointOfContact );
            }
            this.reason = input.reason; // string [string]
            this.requestReason = input.requestReason; // string [string]
            this.resettingPassword = input.resettingPassword; // boolean [boolean]
            if ( input.roles && input.roles.map ) {
                this.roles = input.roles.map( ( x: GenRoleDefinition ) => {
                    return (typeof x === 'string') ? GenRoleDefinition.forName(<string> x) : <any> x; // GenRoleDefinition
                } );
            } else {
                this.roles = input.roles; // GenRoleDefinition
            }
            this.username = input.username; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenUser[] {
        if (arr && arr.map) {
          return arr.map(a => new GenUser(a));
        } else {
          return [];
        }
    }
}

